let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("arF5W")).then(() => parcelRequire('96cJs'));